import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { settingsApi } from '../services/settings';
import { RootState } from './store';
import { SettingsMapper } from 'mappers/settings.mapper';
import { ISettings } from 'interfaces/ISettings';

export interface ISettingsState {
  data: ISettings;
  isLoading: boolean;
  error: string | null;
}

const initialState: ISettingsState = {
  data: null,
  isLoading: false,
  error: null
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSetting: (state, action: PayloadAction<{ key: string; value: any }>) => {
      state.data[action.payload.key] = action.payload.value;
    },
    setSettings: (state, action: PayloadAction<Record<string, any>>) => {
      state.data = { ...state.data, ...action.payload };
    },
    clearSettings: (state) => {
      state.data = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        settingsApi.endpoints.getUserSettings.matchPending,
        (state) => {
          state.isLoading = true;
          state.error = null;
        }
      )
      .addMatcher(
        settingsApi.endpoints.getUserSettings.matchFulfilled,
        (state, { meta, payload }) => {
          state.isLoading = false;
          if (!payload) return;

          state.data = SettingsMapper.afterLoadRequest(payload);
        }
      )
      .addMatcher(
        settingsApi.endpoints.getCompanyIntegrationList.matchFulfilled,
        (state, { meta, payload }) => {
          state.isLoading = false;
          console.log('redux integrationList', payload);
        }
      )
      .addMatcher(
        settingsApi.endpoints.getUserSettings.matchRejected,
        (state, { payload }) => {
          state.isLoading = false;
        }
      )
      .addMatcher(
        settingsApi.endpoints.updateUserSettings.matchFulfilled,
        (state, { payload }) => {
          state.isLoading = false;      
          state.data = SettingsMapper.afterLoadRequest({
            ...payload.body,
            payload,
          });
        }
      );
  },
});

// Selectors
export const selectSettings = (state: RootState) => state.settings.data;
export const selectSetting = (key: string) => (state: RootState) => state.settings.data[key];
export const selectSettingsLoading = (state: RootState) => state.settings.isLoading;
export const selectSettingsError = (state: RootState) => state.settings.error;

// Actions
export const {
  setSetting,
  setSettings,
  clearSettings,
  setLoading,
  setError,
} = settingsSlice.actions;

export default settingsSlice.reducer;
